import { Button, Col, Row, Space, Typography } from "antd";
import dayjs from "dayjs";
import isEmpty from "lodash/isEmpty";
import React from "react";
import { useTranslation } from "react-i18next";
import StatusIcon from "../../assets/icons/status-circle.svg";
import StatusBlackIcon from "../../assets/icons/status-circle-black.svg";
import { ACCEPTED, DELIVERED, MESSAGE_TIME_FORMAT, PENDING } from "../../helpers/constant";
import { IMessage } from "../../helpers/types";
import AvatarComponent from "../AvatarComponent";
import MediaComponent from "../MediaComponent";
import MessagePriceComponent from "../MessagePriceComponent";
import "./index.less";

type props = {
  message: IMessage;
  user?: string;
  isIncome: boolean;
  acceptMessage?: (msg: any) => void;
  rejectMessage?: (messageId: string) => void;
  hideStatus?: boolean;
  username?: string;
  displayVideo?: boolean;
};

const AudioMediaItemComponent: React.FC<props> = ({ 
  message, 
  user, 
  isIncome, 
  acceptMessage, 
  rejectMessage, 
  hideStatus, 
  username,
  displayVideo = false
}) => {
  const { t } = useTranslation();
  const messageTime = dayjs(message?.createdAt);
  const isAccepted = message?.status === ACCEPTED;
  
  if (isIncome) {
    // Incoming message (from creator)
    return (
      <div className={`incomeMessage min-width-media`}>
        {user && <AvatarComponent image={user} size={23} />}
        <Row className="incomeMessageBox">
          <Space className="w-full gap-10" direction="vertical">
            {message?.mediaPushPrice !== undefined && <MessagePriceComponent message={message} income={true} />}
            
            <Row className={"mediaRow"}>
              {message.medias && message.medias.map((media) => (
                <MediaComponent
                  key={media.fileId}
                  width={68}
                  height={68}
                  borderRadius={11}
                  image={media.url || ""}
                  isPrivate={isIncome ? (media.isPrivate && message.status !== ACCEPTED) : false}
                  isVideo={false}
                  isAudio={true}
                  url={media.url}
                  username={username || ""}
                  shouldAddWatermark={false}
                  displayVideo={displayVideo || message.status === ACCEPTED}
                />
              ))}
            </Row>
            
            {message?.text && (
              <Row align="middle" style={{ width: "100%" }}>
                <Col span={24}>
                  <div style={{ display: "flex", alignItems: "flex-end", width: "100%" }}>
                    <Typography.Text className="message-style">{message.text}</Typography.Text>
                  </div>
                </Col>
              </Row>
            )}
            
            {message?.status === PENDING && (
              <Row>
                <Space style={{ width: "100%", justifyContent: "space-between", alignItems: "flex-end" }}>
                  <Col style={{ display: "flex" }}>
                    <Button className="accept-media-button" onClick={() => acceptMessage && acceptMessage(message)}>
                      {t("accept")}
                    </Button>
                    <Button className="reject-media-button" onClick={() => rejectMessage && rejectMessage(message._id || "")} style={{ marginLeft: "10px" }}>
                      {t("refuse")}
                    </Button>
                  </Col>
                  <Col>
                    {messageTime && (
                      <Typography.Text className="message-time text-white-color" style={{ paddingLeft: "10px" }}>
                        {messageTime.format(MESSAGE_TIME_FORMAT)}
                      </Typography.Text>
                    )}
                  </Col>
                </Space>
              </Row>
            )}
            
            {message?.status !== PENDING && !hideStatus && (
              <Row className="mt-10">
                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                  <Col>
                    <img src={StatusIcon} alt={message?.status || ""} />
                    <Typography.Text className="font-14-bold text-white-color pl-4">
                      {t(message?.status || "")}
                    </Typography.Text>
                  </Col>
                  <Col>
                    {messageTime && (
                      <Typography.Text className="message-time text-white-color">
                        {messageTime.format(MESSAGE_TIME_FORMAT)}
                      </Typography.Text>
                    )}
                  </Col>
                </Space>
              </Row>
            )}
          </Space>
        </Row>
      </div>
    );
  } else {
    // Outgoing message (from fan)
    return (
      <div className={`outgoingAudioMessage ${isAccepted ? "accepted" : ""}`}>
        <Space className="w-full gap-10" direction="vertical">
          {message?.mediaPushPrice !== undefined && <MessagePriceComponent message={message} income={false} />}
          
          <Row className={"mediaRow"}>
            {message.medias && message.medias.map((media) => (

              <MediaComponent
                key={media.fileId}
                width={68}
                height={68}
                borderRadius={11}
                image={media.url || ""}
                isPrivate={isIncome ? (media.isPrivate && message.status !== ACCEPTED) : false}
                isVideo={false}
                isAudio={true}
                url={media.url}
                username={username || ""}
                shouldAddWatermark={false}
                displayVideo={displayVideo || message.status === ACCEPTED}
              />
              // <></>
            ))}
          </Row>
          
          {message?.text && (
            <Row align="middle" style={{ width: "100%" }}>
              <Typography.Text className="message-style">{message.text}</Typography.Text>
            </Row>
          )}
          
          {!hideStatus && (
            <Row className="mt-10">
              <Space style={{ width: "100%", justifyContent: "space-between" }}>
                <div>
                  <img src={StatusBlackIcon} alt={message?.status || ""} />
                  <Typography.Text className="font-14-bold text-black-color pl-4">
                    {t(message?.status || "")}
                  </Typography.Text>
                </div>
                <div>
                  {messageTime && (
                    <Typography.Text className="message-time">
                      {messageTime.format(MESSAGE_TIME_FORMAT)}
                    </Typography.Text>
                  )}
                </div>
              </Space>
            </Row>
          )}
        </Space>
      </div>
    );
  }
};

export default AudioMediaItemComponent;
